module.exports = __webpack_public_path__ + "241c9d23e596a8c87352cfec74c2a42c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/textarea_up.png
// module id = 286
// module chunks = 0